import { Link, routes } from "wasp/client/router";
import { Card, CardContent } from "../../client/components/ui/card";
import { CardSectionHeader } from "../../client/components/ui/card-section-header";
import { Button } from "../../client/components/ui/button";
import { Plus, Target } from "lucide-react";
import { useDashboardData } from "./DashboardDataContext";

export default function GoalsWidget() {
  const { goals, topGoals, isDark, readOnly, t } = useDashboardData();
  return (
    <Card className="h-full">
      <CardSectionHeader
        label={t.dashboard.topGoals}
        isDark={isDark}
        compact
        rightContent={
          <Link to={routes.TradingGoalsRoute.to}>
            <Button variant="ghost" size="sm" className="h-6 px-2 text-xs">{t.dashboard.viewAll}</Button>
          </Link>
        }
      />
      <CardContent className="px-4 pb-3 pt-1">
        {(goals?.length ?? 0) === 0 ? (
          <div className="flex flex-col items-center justify-center py-2 gap-1.5 text-center">
            <Target className="h-5 w-5 text-muted-foreground/40" />
            <p className="text-xs text-muted-foreground leading-tight">{t.dashboard.noGoalInProgressDesc}</p>
            {!readOnly && (
              <Link to={routes.TradingGoalsRoute.to}>
                <Button size="sm" variant="default" className="text-xs h-6 px-2">
                  <Plus className="h-3 w-3 mr-1" />
                  {t.dashboard.createFirstGoal}
                </Button>
              </Link>
            )}
          </div>
        ) : topGoals.length === 0 ? (
          <div className="flex items-center gap-2 py-1">
            <Target className="h-4 w-4 text-primary shrink-0" />
            <p className="text-xs text-muted-foreground">{t.dashboard.allGoalsCompletedDesc}</p>
          </div>
        ) : (
          <div className="space-y-2.5">
            {topGoals.map(({ goal, progress, daysLeft }: any) => (
              <div key={goal.id}>
                <div className="flex items-center justify-between mb-1 gap-1">
                  <span className="text-xs truncate">{goal.title}</span>
                  <div className="flex items-center gap-1 shrink-0">
                    {daysLeft !== null && daysLeft >= 0 && (
                      <span className={`text-[9px] font-semibold px-1 py-0.5 rounded-full ${
                        daysLeft <= 2 ? "bg-red-500/10 text-red-400" :
                        daysLeft <= 7 ? "bg-amber-500/10 text-amber-400" :
                        "bg-muted text-muted-foreground"
                      }`}>
                        {daysLeft === 0 ? t.dashboard.today : `${daysLeft}j`}
                      </span>
                    )}
                    <span className="text-[10px] font-semibold text-primary">{progress.toFixed(0)}%</span>
                  </div>
                </div>
                <div className="w-full h-1 bg-muted rounded-full overflow-hidden">
                  <div
                    className="h-full rounded-full bg-primary transition-all"
                    style={{ width: `${progress}%` }}
                  />
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
